import { createTheme } from '@mui/material/styles'
import { THEMES_ARRAY, THEMES_NAME, variantStyles } from './constants'
import { cssBaseLineConfig } from './cssBaseLine'

const getThemeObject = () => {
  const themeName = THEMES_NAME.sweet
  return THEMES_ARRAY.find((ele) => ele.value === themeName)
}
const themeObject = getThemeObject()

//Custom lại các component
const SweetTheme = createTheme({
  typography: {
    fontFamily: 'Gilroy, san-serif',
    htmlFontSize: 10,
  },

  components: {
    MuiCssBaseline: cssBaseLineConfig,
    MuiButton: {
      // custom button dùng chung có 2 loại button thường xử dụng là primary, secondary.
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          const { primary, secondary, disabledColor } = theme.palette
          const isDisabled = ownerState.disabled
          const textWhite = `${primary.contrastText} !important`

          switch (ownerState.variant) {
            case 'contained':
              return {
                borderRadius: 15,
                textTransform: 'none',
              }

            case 'primary':
              return {
                textTransform: 'none',
                backgroundColor: isDisabled ? disabledColor.main : primary.main,
                color: textWhite,
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: primary.main,
                },
              }

            case 'secondary':
              return {
                textTransform: 'none',
                backgroundColor: isDisabled ? disabledColor.main : secondary.main,
                color: textWhite,
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: secondary.main,
                },
              }

            case variantStyles.btnOrder:
              return {
                textTransform: 'none',
                backgroundColor: themeObject.color5,
                color: themeObject.colorText2,
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: themeObject.color5,
                },
                '&.Mui-disabled': {
                  opacity: 0.5,
                },
              }

            case variantStyles.btnAddToOrder:
              return {
                textTransform: 'none',
                backgroundColor: themeObject.color2,
                color: themeObject.colorText2,
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: themeObject.color2,
                },
              }

            default:
              return {
                textTransform: 'none',
                borderRadius: 10,
              }
          }
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          const { baseColor } = theme.palette
          if (ownerState.variant === 'active') {
            return {
              marginRight: 12,
              border: `1.5px solid ${baseColor.color5}`,
              backgroundColor: baseColor.colorText1,
              color: baseColor.colorText2,
              borderRadius: 30,
              padding: '18px 8px',
            }
          }
          if (ownerState.variant === 'unactive') {
            return {
              marginRight: 12,
              border: `1.5px solid ${baseColor.colorText1}`,
              backgroundColor: baseColor.color1,
              color: baseColor.colorText1,
              borderRadius: 30,
              padding: '18px 8px',
            }
          }
        },
      },
    },
  },
  palette: {
    orange: {
      main: '#ff8f1f',
    },
    disabledColor: {
      main: '#CECECE',
      contrastText: '#929292',
      secondary: '#F3F3F3',
    },
    primary: {
      main: '#ff8f1f',
      contrastText: 'white',
    },
    secondary: {
      main: '#000',
      dark: '#101820',
    },
    text: {
      main: '#101820',
    },
    pureBlack: {
      main: '#000',
    },
    statusColor: {
      cancelled: '#EB4319',
      prepared: '#40ACDD',
    },
    baseColor: {
      main: themeObject.color1,
      color1: themeObject.color1, // #FAE1E6
      color2: themeObject.color2, // #000000
      color3: themeObject.color3, // #FFFFFF
      color4: themeObject.color4, // #52977E
      color5: themeObject.color5, // #FF5E79
      color6: themeObject.color6, // #000000
      color7: themeObject.color7, // #F3B2BD
      color8: themeObject.color8, // #AFCCFF
      color9: themeObject.color9, // #AFCCFF
      color10: themeObject.color10, //#000000
      color11: themeObject.color11,
      color12: themeObject.color12,
      color13: themeObject.color13,
      color14: themeObject.color14,
      color15: themeObject.color15,
      color16: themeObject.color16,
      color17: themeObject.color17,
      color18: themeObject.color18,
      color19: themeObject.color19,
      colorText1: themeObject.colorText1, // #000000
      colorText2: themeObject.colorText2, // #FFFFFF
      colorText3: themeObject.colorText3,
      colorText4: themeObject.colorText4,
      colorText5: themeObject.colorText5,
      colorText6: themeObject.colorText6,
      colorText7: themeObject.colorText7,
      colorText8: themeObject.colorText8,
      colorText9: themeObject.colorText9,
      starDefault: themeObject.starDefault,
      starActive: themeObject.starActive,
    },
  },
})

export default SweetTheme

export const { statusColor, primary } = SweetTheme.palette
